// iInvest - SPUL
// iWealthy - RPUL
// iLink - RPUDR

export const URL_OPEN_VIDEO = {
  RPUL: 'https://youtu.be/pVB-3lo_mbo',
  SPUL: 'https://youtu.be/IhdUAjhA6Dk',
  RPUDR: 'https://youtu.be/ey-n1ZnA0g4',
}

export const URL_DOWNLOAD_PDF = {
  RPUL: 'https://ktaxa.live/SalesSheetforiWealthy',
  SPUL: 'https://ktaxa.live/SalesSheetforiInvest',
  RPUDR: 'https://ktaxa.live/SalesSheetiLink',
}
